<header class="notification__header">
    <h1 class="notification__title">
        {{'notification.title' | translate}}
    </h1>
    <button class="notification__close-button"
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate"
            (click)="close()">
        <mat-icon svgIcon="notification__close"></mat-icon>
    </button>
</header>

<app-notif-list></app-notif-list>
